import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import dictionary from 'config/dictionary';
import styles from './card.module.scss';
import {
  ButtonArrowState,
  Button as TitleTypography,
  TertiaryButton
} from '@huggg/react-components';
import { interpolate } from 'utilities/interpolate';
import { fallbackError } from 'utilities/errorHandling';

const CardContent = ({
  brandAssets,
  brandName,
  isBlueHuggg,
  voucherAmount,
  formattedVoucherExpiry,
  processedVoucherLabel,
  isWaitingForFulfil,
  onClaimCard,
  voucherError
}) => {
  const itemType = isBlueHuggg ? 'voucher' : 'gift card';
  const capitalizedItemType =
    itemType.charAt(0).toUpperCase() + itemType.slice(1);

  const fallbackErrorMessage = fallbackError(itemType, 'loading');

  return (
    <div
      style={{
        gap: '35px',
        marginTop: '35px'
      }}
      className={styles.columnCenter}
    >
      <TitleTypography className={classnames(styles.title)}>
        Your {brandName} {itemType} is ready!
      </TitleTypography>
      <img
        src={brandAssets.giftCardUrl}
        alt={'gift-card'}
        className={styles.cardImage}
      />
      <TitleTypography className={classnames(styles.title)}>
        {capitalizedItemType} value:{' '}
        <span style={{ fontWeight: 'bold' }}>{voucherAmount}</span>
      </TitleTypography>
      {formattedVoucherExpiry && (
        <p className={styles.voucherExpiry}>
          {interpolate(
            dictionary.voucherExpiry,
            '[expiry_date]',
            <>{formattedVoucherExpiry}</>
          )}
        </p>
      )}
      <TitleTypography
        className={classnames(styles.title)}
        style={{ fontWeight: 500 }}
      >
        Ready to make a purchase?
      </TitleTypography>
      <div
        style={{
          gap: '15px'
        }}
        className={styles.columnCenter}
      >
        <TertiaryButton
          loading={isWaitingForFulfil}
          className={styles.voucherButton}
          onClick={onClaimCard}
          data-test-id="button-visit-external"
          label={processedVoucherLabel}
          arrow={ButtonArrowState.None}
        />

        {voucherError && (
          <div className={styles.error}>{fallbackErrorMessage}</div>
        )}
      </div>
    </div>
  );
};

CardContent.propTypes = {
  brandAssets: PropTypes.object.isRequired,
  brandName: PropTypes.string,
  voucherAmount: PropTypes.string,
  formattedVoucherExpiry: PropTypes.string,
  processedVoucherLabel: PropTypes.string,
  isWaitingForFulfil: PropTypes.bool.isRequired,
  onClaimCard: PropTypes.func.isRequired,
  voucherError: PropTypes.object
};

export default CardContent;
